<template>
<div class="row">
    <loading v-if="loading"></loading>
    <template v-if="!loading">
        <div class="col-xs-10">
            <h1>{{ t.adverts }}</h1>
        </div>
        <div class="col-xs-2" v-if="config.data.owner">
            <a class="btn btn-primary pull-right" :href="pages.advertCreate">
                {{ t.create_advert }}
            </a>
        </div>
        <div class="col-xs-12">
            <advert-card v-if="adverts.length" v-for="advert in adverts" :key="advert.id" :advert="advert"
                :t="t" :adverts-highlight="advertsHighlight"></advert-card>
            <p v-if="!adverts.length">{{ t.no_adverts }}</p>
        </div>
    </template>
</div>
</template>

<script>
import AdvertCard from 'Adverts/component/AdvertCard.vue';
import ajax from 'Site/js/util/ajax.fetch';
import Loading from 'Site/component/Loading.vue';
import { mapState } from 'vuex';

export default {
    name: 'ProfileAdverts',
    components: {
        AdvertCard,
        Loading
    },
    computed: mapState(['config']),
    data() {
        return {
            adverts: [],
            advertsHighlight: false,
            loading: true,
            pages: {},
            t: {},
        };
    },
    created() {
        const setData = (settings) => {
            settings = JSON.parse(settings);
            this.adverts = settings.data.adverts;
            this.advertsHighlight = settings.data.advertsHighlight;
            this.pages = settings.pages;
            this.t = settings.translate;
            this.loading = false;
        };
        if (document.querySelector('#adverts-json')) {
            const settings = document.querySelector('#adverts-json').textContent;
            if (settings) {
                setData(settings);
            }
        } else {
            ajax.get(window.location.href).then((data) => {
                setData(data);
            });
        }
    }
};

</script>
